import { createActionGroup, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { ConversationModel, GroupedConversationRecord } from '../models/ace-conversations.model';
import { IServerSideGetRowsRequest } from 'ag-grid-community/dist/types/src/interfaces/iServerSideDatasource';

export const CONVERSATIONS_REPORT_API_ACTIONS = createActionGroup({
  source: 'Conversations SSR API',
  events: {
    get: props<{ request: Partial<IServerSideGetRowsRequest> }>(),
    success: props<{ conversations: ConversationModel[] | GroupedConversationRecord[]; totalCount: number }>(),
    error: props<{ error: HttpErrorResponse }>(),
  },
});

export const CONVERSATIONS_REPORT_ACTIONS = createActionGroup({
  source: 'Conversations Report',
  events: {
    setActiveView: props<{ viewName: string | null }>(),
  },
});
